<template>
<div class='api-application login-form'>

  <h1>申请 API 使用权限</h1>

  <el-form label-thin class='application-form' label-width="80px">
    <el-form-item label="姓名">
      <el-input v-model="application.name"></el-input>
    </el-form-item>

    <el-form-item label="电话" :error="errors.first('cellphone')">
      <el-input v-model="application.phone"></el-input>
    </el-form-item>

    <el-form-item label="公司">
      <el-input v-model="application.company"></el-input>
    </el-form-item>

    <el-form-item label="使用场景">
      <el-input v-model="application.scenario" placeholder="如教育课件，市场营销等"></el-input>
    </el-form-item>

    <el-form-item label="使用数量">
      <el-input v-model="application.estimate_ppts" placeholder="预计转化数量，如一年两万次"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="sendApplication" style="float: left;">提交</el-button>
    </el-form-item>
  </el-form>

</div>
</template>

<style lang='scss' scoped>
.api-application {}
</style>

<script>
import regexes from '@/config/regexes'
import Validator from '@/mixins/validator'

export default {
  data() {
    return {
      sended: false,
      application: {
        name: null,
        phone: null,
        company: null,
        scenario: null,
        estimate_ppts: null
      }
    }
  },
  mixins: [Validator],
  methods: {
    sendApplication() {
      let vm = this
      if (vm.sended) {
        vm.$contactApiApplication()
        return
      }

      // do validation
      vm.errors.clear()
      if (!regexes.cellphone.test(vm.application.phone)) {
        vm.errors.add('cellphone', '手机号码格式不正确')
        return
      }

      vm.$store.dispatch('apis/sendApplication', vm.application).then(res => {
        vm.$contactApiApplication()
        vm.sended = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// api_application.view.vue?4ddf517e